import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=28eae13a&scoped=true&"
import script from "./TagManager.vue?vue&type=script&lang=ts&"
export * from "./TagManager.vue?vue&type=script&lang=ts&"
import style0 from "./TagManager.vue?vue&type=style&index=0&id=28eae13a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eae13a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28eae13a')) {
      api.createRecord('28eae13a', component.options)
    } else {
      api.reload('28eae13a', component.options)
    }
    module.hot.accept("./TagManager.vue?vue&type=template&id=28eae13a&scoped=true&", function () {
      api.rerender('28eae13a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagManager.vue"
export default component.exports